import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="split-source"
export default class extends Controller {
  static targets = ["newStartDate", "sourceEndDate"]

  connect() {
    this.update()
  }

  update() {
    // 1. Parse new start date
    const rawNewStart = this.newStartDateTarget.value
    if (!rawNewStart) return

    const [newYear, newMonth, newDay] = rawNewStart.split("-").map(Number)
    const newStartDate = new Date(newYear, newMonth - 1, newDay)

    // 2. Calculate adjusted end date (day before new start)
    const adjustedEndDate = new Date(newStartDate)
    adjustedEndDate.setDate(adjustedEndDate.getDate() - 1)

    // 3. Parse original start date from data attribute
    const rawOriginalStart = this.sourceEndDateTarget.dataset.splitSourceStartDate
    const [origYear, origMonth, origDay] = rawOriginalStart.split("-").map(Number)
    const originalStartDate = new Date(origYear, origMonth - 1, origDay)

    // 4. Format adjusted end date for display
    const formatted = adjustedEndDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric"
    })
    this.sourceEndDateTarget.textContent = formatted

    // 5. Compare adjusted end date with original start date
    if (adjustedEndDate < originalStartDate) {
      this.sourceEndDateTarget.classList.add("text-danger")
    } else {
      this.sourceEndDateTarget.classList.remove("text-danger")
    }
  }
}
